import { useTranslation } from "@coworker/locales";
import { ARTICLE_HASH } from "@coworker/app/src/components/TestBuy/constants";
import { getStrategyTranslationKey } from "@coworker/apprestructured/src/testbuy/helpers/getStrategyTranslationKey";

// testbuy notifications send the raw strategy value (e.g. "RANDOM") as the description
export function useNotificationDescriptionString(description: string): string {
  const { t } = useTranslation();

  const isTestbuyStrategy = Object.values(ARTICLE_HASH).some(
    (article) => article?.type === description
  );
  if (isTestbuyStrategy) {
    return t(getStrategyTranslationKey(description));
  }
  return description;
}
